import intl from 'react-intl-universal'

/* globals $ */

// Simple duck-typing for ANS
export const isAns = (data) =>
  Array.isArray(data) && data.length > 0
    ? isAns(data[0])
    : data._id && data.version && data.type

function thirdPartyIntegration($q, _fn) {
  return function(
    api,
    showButtons = ['cancel', 'select'],
    modalSize,
    options = {}
  ) {
    const {
      className = '',
      receiveMessage: customReceiveMessage,
      buttons: customButtons = {},
      setDeferred,
      setIframeAndDialog,
    } = options
    var deferred = $q.defer()

    if (setDeferred) {
      setDeferred(deferred)
    }

    var dialogElem = $('#dialog-thirdParty')
    if (!dialogElem.length) {
      var template =
        `<div id="dialog-thirdParty" title="" class="${className}">` +
        '<iframe id="dialog-thirdParty-iframe"></iframe>' +
        '</div>'
      dialogElem = $(template).appendTo(document.body)
    }

    var ifr = $('#dialog-thirdParty-iframe').attr('src', api)
    if (setIframeAndDialog) {
      setIframeAndDialog(ifr, dialogElem)
    }

    const allButtons = {
      cancel: {
        click: function() {
          $(this).dialog('close')
          deferred.reject()
        },
        text: intl.get('addItemPlugin.BaseModal.cancel'),
        class: 'btn',
      },
      select: {
        click: function() {
          // this one is for same origin ellipsis search results
          window.parent.postMessage('returnSelectedANS', window.location.origin)
          ifr
            .get(0)
            .contentWindow.postMessage(
              'returnSelectedANS',
              window.location.origin
            )
          ifr
            .contents()
            .find('.tools-row button.btn-green')
            .click() // temp fix until they add listener
        },
        text: intl.get('addItemPlugin.BaseModal.select'),
        class: 'btn btn-success',
      },
      done: {
        // general do-nothing close action.
        click: function() {
          $(this).dialog('close')
          deferred.resolve()
        },
        text: 'Done',
        class: 'btn btn-success',
      },
      ...customButtons,
    }
    let buttons = _fn.copyKeys(showButtons)(allButtons)

    let skinny = Object.keys(buttons).length === 0 // if we have no buttons at all, let iframe contents take up all space
    let closeOnEsc = showButtons.indexOf('esc') !== -1

    let classes = {}
    if (skinny) {
      classes['ui-dialog-content'] = 'p-0 m-0 no-scroll'
    }

    $('#dialog-thirdParty').dialog({
      dialogClass: 'removeTitle',
      resizable: false,
      height:
        modalSize && modalSize[1] ? modalSize[1] : $(window).height() - 100,
      width: modalSize && modalSize[0] ? modalSize[0] : $(window).width() - 100,
      modal: true,
      classes,
      closeOnEscape: closeOnEsc,
      buttons,
      close: function() {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        window.removeEventListener('message', receiveMessage)
        $('#dialog-thirdParty').remove()
      },
    })

    var receiveMessage =
      customReceiveMessage ||
      function(evt) {
        // This is also used for websked so don't check ans if there is a valid eventType
        if (
          !(evt.data && evt.data.eventType) &&
          (evt.data === 'returnSelectedANS' || !isAns(evt.data))
        ) {
          return
        }
        console.log(evt.data)
        deferred.resolve(evt.data)
        $('#dialog-thirdParty').dialog('close')
      }

    // Listen for the post message from the iframe.
    window.addEventListener('message', receiveMessage, false)

    return deferred.promise
  }
}

export default ['$q', 'fnService', thirdPartyIntegration]
